import React, { useEffect, useState, memo } from "react";
import { Row } from "react-bootstrap";
import { callApi, validateToken } from "../../../lib/utils";
import TaskNoteForm from "./TaskNoteForm";
import TaskNoteHeader from "./TaskNoteHeader";
import TaskNotesList from "./TaskNotesList";
import PulseLoader from "react-spinners/PulseLoader";
const TaskNotes = ({ data, payload, patientData }) => {
  const [notesList, setNotesList] = useState([]);
  const [noteTypes, setNoteTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    validateToken((err) => {
      if (err) {
        // console.log(err);
        window.location = "/logout";
      }
      callApi(`/api/patient/note/types`, {}, "GET")
        .then((response) => {
          const temp = response?.data.data?.noteTypes
            ? response?.data.data?.noteTypes.map((item) => {
              return { id: item.id, name: item.noteType };
            })
            : [];
          setNoteTypes(temp);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
      setLoading(true);
      callApi(
        `/api/patient/note/list`,
        {
          page: 1,
          limit: 20,
          filters: payload
            ? payload
            : {
              patientId: data?.patientId,
              //"noteTypeId": 3,
              noteModuleId: 2,
              referenceId: data?.referenceId,
              patientTaskId: data?.id,
              eventTypeId: parseInt(data?.eventType),
            },
        },
        "POST"
      )
        .then((response) => {
          setNotesList(response?.data?.data?.notes);
          setLoading(false);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    });
  }, []);

  return (
    <>
      <TaskNoteHeader data={data} />
      <Row>
        <TaskNotesList
          noteTypes={noteTypes}
          notesList={notesList}
          heading="NOTE HISTORY"
          col={8}
          data={data}
          patientData={patientData}
          noteModuleId={payload ? 1 : 2}
          patientTaskId={payload ? data?.id : null}
          loading={loading}
        />
        <TaskNoteForm
          noteTypes={noteTypes}
          data={data}
          notesList={notesList}
          eventTypeId={payload ? payload.eventTypeId : null}
          noteModuleId={payload ? 1 : 2}
          patientTaskId={payload ? null : data?.id}
        />
      </Row>
    </>
  );
};

export default memo(TaskNotes);
